import { useEffect, useState } from 'react';
import {
  Box,
  Collapse,
  FormControl,
  InputAdornment,
  InputLabel,
  TextField,
  Typography,
} from '@mui/material';

import inputStyles from './inputStyles';
import { emailRegex, onlyLatinCharacters } from '../../library/utils';

const StyledTextField = (props) => {
  const {
    id,
    label,
    note,
    placeholder,
    type,
    defaultValue,
    value,
    required,
    disabled,
    error,
    errorMessage,
    helperText,
    handleChange,
    formControlClassName,
    // inputLabelTypographyStyle,
    startAdornment,
    endAdornment,
    formControlVariant,
    textFieldVariant,
    boxComponent,
    boxSx,
    noLeftPaddingTextField,
    maxLength,
    fullWidth,
    disableUnderline,
    isValidateLatin,
    touched,
  } = props;
  const styles = inputStyles();

  const [onBlur, setOnBlur] = useState(!!touched);

  useEffect(() => {
    setOnBlur(!!touched);
  }, [touched]);

  const validateEmail = (value) => {
    return emailRegex.test(value);
  };

  const validateLatin = (value) => {
    if (isValidateLatin && value) {
      return onlyLatinCharacters(value);
    }

    return true;
  };

  let conditionalSelectProps = {};
  if (disableUnderline) {
    conditionalSelectProps = {
      disableUnderline:
        formControlVariant === 'outlined' ? undefined : disableUnderline,
    };
  }

  const textFieldProps = {
    id,
    placeholder,
    type: type ? (type === 'passwordtext' ? 'text' : type) : 'text',
    value,
    required,
    disabled,
    error:
      error ||
      (required && !value && onBlur) ||
      (type === 'email' && !validateEmail(value) && onBlur) ||
      (type === 'text' && !validateLatin(value) && onBlur),
    onChange: handleChange,
    variant: textFieldVariant,
    inputProps: {
      maxLength,
    },
    InputProps: {
      maxLength,
      classes: {
        input: noLeftPaddingTextField
          ? styles.textFieldNoLeftPaddingRoot
          : styles.textFieldRoot,
      },
      startAdornment: startAdornment && (
        <InputAdornment position="start">{startAdornment}</InputAdornment>
      ),
      endAdornment: endAdornment && (
        <InputAdornment position="end">{endAdornment}</InputAdornment>
      ),
    },
    ...conditionalSelectProps,
  };

  if (value === undefined || value === null) {
    textFieldProps.defaultValue = defaultValue || '';
  }

  return (
    <Box component={boxComponent} sx={boxSx} mb={1}>
      {label && (
        <InputLabel
          required={required}
          sx={{
            '& .MuiInputLabel-asterisk': {
              color: 'red',
            },
          }}
        >
          {/* <Typography style={inputLabelTypographyStyle}>{label}</Typography> */}
          {label}
        </InputLabel>
      )}
      {note && (
        <InputLabel>
          <Typography fontSize="0.7rem">{note}</Typography>
        </InputLabel>
      )}
      <FormControl
        fullWidth={fullWidth}
        variant={formControlVariant}
        className={formControlClassName || styles.formControlTextFieldClass}
      >
        <TextField {...textFieldProps} onBlur={() => setOnBlur(true)} />
      </FormControl>
      {helperText && (
        <InputLabel>
          <Typography
            sx={{ wordBreak: 'break-all', whiteSpace: 'normal' }}
            fontSize="0.7rem"
          >
            {helperText}
          </Typography>
        </InputLabel>
      )}
      <Collapse
        in={
          error ||
          (required && !value && onBlur) ||
          (type === 'email' && !validateEmail(value) && onBlur) ||
          (type === 'text' && !!value && !validateLatin(value) && onBlur)
        }
      >
        <InputLabel>
          <Typography fontSize="0.7rem" color="red">
            {errorMessage ||
              (required && !value && onBlur && `${label} is required.`) ||
              (type === 'email' &&
                !validateEmail(value) &&
                onBlur &&
                'Invalid email.') ||
              (type === 'text' &&
                value &&
                !validateLatin(value) &&
                onBlur &&
                'Invalid characters.')}
          </Typography>
        </InputLabel>
      </Collapse>
    </Box>
  );
};

export default StyledTextField;
